var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.14,
    y: 6.81,
    width: 1.94,
    height: 1.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.03,
    y: 6.81,
    width: 1.94,
    height: 1.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.92,
    y: 6.81,
    width: 1.94,
    height: 1.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.14,
    y: 10.69,
    width: 1.94,
    height: 1.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.03,
    y: 10.69,
    width: 1.94,
    height: 1.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.92,
    y: 10.69,
    width: 1.94,
    height: 1.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.67,1.56V.78a.78.78,0,0,0-1.56,0v.78H3.89V.78a.78.78,0,0,0-1.56,0v.78H0V14.78H14V1.56Zm1.75,12.64H.58V5.25H13.42Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4d38e4d83b6a2f29aa0a4de246864b68.svg";
export { ForwardRef as ReactComponent };